import React from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { Button } from "react-bootstrap";

function Callicon() {
  const phoneNumber = "+9981268611";

  return (
    <a href={`tel:${phoneNumber}`} className="call-float" aria-label="Call Ayushi Construction">
      <Button variant="primary" className="call-btn">
        <FaPhoneAlt size={24} />
      </Button>

      <style>
        {`
          .call-float {
            position: fixed;
            bottom: 35px;
            right: 10px;
            z-index: 1000;
            text-decoration: none;
          }

          .call-btn {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: transform 0.3s ease-in-out;
          }

          .call-btn:hover {
            transform: scale(1.1);
          }
        `}
      </style>
    </a>
  );
}

export default Callicon;
